import { Moon, Sun } from 'lucide-react';
import { useAppStore } from '../../store/appStore';

/**
 * Botón claro/oscuro (pedido del owner). Invierte el tema actual y lo
 * persiste como preferencia personal (localStorage): al volver, la superficie
 * abre con el tema elegido. La Pantalla no lo lleva — proyección navy fija.
 */
export function BotonTema() {
  const theme = useAppStore((s) => s.theme);
  const toggleTheme = useAppStore((s) => s.toggleTheme);
  const aOscuro = theme === 'light';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={aOscuro ? 'Cambiar a tema oscuro' : 'Cambiar a tema claro'}
      title={aOscuro ? 'Tema oscuro' : 'Tema claro'}
      className="flex min-h-touch min-w-touch items-center justify-center rounded-md text-content-muted transition-colors duration-fast hover:bg-surface-sunken hover:text-content focus-visible:outline-none focus-visible:shadow-focus"
    >
      {aOscuro ? (
        <Moon className="h-5 w-5" aria-hidden="true" />
      ) : (
        <Sun className="h-5 w-5" aria-hidden="true" />
      )}
    </button>
  );
}
